export default "__VITE_PUBLIC_ASSET__b3d6c1d0__"